import startOfWeek from 'date-fns/start_of_week';
import endOfWeek from 'date-fns/end_of_week';
import addDays from 'date-fns/add_days';

export default function getRunningWeek(adjustment = 0) {
  const adjustedDays = addDays(new Date(), adjustment);

  return {
    from: startOfWeek(adjustedDays),
    to: endOfWeek(adjustedDays),
  };
};
